import React from "react";
import {
  Button,
  Modal
} from "reactstrap";
import { toast } from 'react-toastify';

import { confirmLeave } from "../../services/leaveService";
import SpinDiv from "../components/SpinDiv";

class ConfirmLeave extends React.Component {
	constructor(props) {
		super(props);
    this.state = {
      leave: props.confirmLeave,
      loading: false,
      search: '',
      validation: {},
      name: ''
    };
	}

  componentDidMount() {
    toast.configure({hideProgressBar: true, closeButton: false});
  }

  showToast = msg => {
    toast(<div style={{ padding: 20, color: "green" }}>{msg}</div>);
  }
   showToastError = (msg) => {
    toast(<div style={{ padding: 20, color: "red" }}>{msg}</div>);
  };
  onConfirm = () => {
    this.setState({saving: true});
    const {leave} = this.state;
    console.log(leave);
    confirmLeave(leave.id)
      .then(res => {
          console.log(res)
          this.setState({saving: false});
          this.props.saved();
          this.props.toggle();
          this.showToast('Leave Confirmed')
      },
    	error => {
        this.showToastError('Leave could not be confirmed, Active Leave days Exceeded for that year')
        this.setState({saving: false});
    	});
  }
  

 

  render() {
    const {  toggle } = this.props
    const {loading, leave, saving} = this.state;
    return (
      <>
        <Modal
          className="modal-dialog-centered"
          isOpen={leave!=null}
          toggle={() => !saving&&toggle}
          style={{maxWidth: 600}}
        >
          {saving&&<SpinDiv text={'confirming...'} />}
          <div className="modal-header" style={{padding: '1rem'}}>
            <h3 className="modal-title" id="exampleModalLabel">
              Confirm leave for - {leave.name}
            </h3>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={toggle}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body" style={{border: '1px solid #eee'}}>
            Are you sure you want to confirm this Leave? <br/><br/>
             
          </div>
          <div className="modal-footer" style={{padding: '1rem'}}>
           
            <Button color="success" type="button" disabled={loading} size="sm"
              onClick={this.onConfirm}
              variant='outline-success'
              >
              Confirm
            </Button>
            <Button
              size="sm"
              variant='outline-secondary'
              data-dismiss="modal"
              type="button"
              disabled={loading}
              onClick={toggle}
            >
              Cancel
            </Button>
          </div>
        </Modal>
      </>
    );
  }
}

export default ConfirmLeave;
